<span class="badge {{cssService.getLine(line())}} {{abbreviate() ? 'fixed-width' : ''}}">{{getName()}}</span>